import React, { useState } from 'react'
import { useCoupon } from '../hooks/useCoupon'
import './CouponInput.css'

type CouponInputProps = {
  onCouponApplied?: (coupon: any) => void
}

/**
 * Composant pour saisir et valider un code coupon
 */
const CouponInput: React.FC<CouponInputProps> = ({ onCouponApplied }) => {
  const [code, setCode] = useState('')
  const { coupon, loading, error, validateCoupon, clearCoupon } = useCoupon()

  const handleApply = async () => {
    if (!code.trim()) return

    const validatedCoupon = await validateCoupon(code)
    if (validatedCoupon && onCouponApplied) {
      onCouponApplied(validatedCoupon)
    }
  }

  const handleRemove = () => {
    clearCoupon()
    setCode('')
    if (onCouponApplied) {
      onCouponApplied(null)
    }
  }

  // Si un coupon est déjà appliqué
  if (coupon) {
    return (
      <div className="coupon-applied" data-testid="coupon-applied">
        <div className="coupon-info">
          <span className="coupon-icon">🎟️</span>
          <div>
            <strong>{coupon.code}</strong>
            {coupon.partner && (
              <p className="partner-name">
                {(coupon.partner as any).name}
              </p>
            )}
            <p className="discount-info">
              Réduction: -{coupon.user_discount_pct ?? coupon.member_discount_pct}%
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleRemove}
          className="remove-button"
          data-testid="remove-coupon-button"
        >
          ✕
        </button>
      </div>
    )
  }

  return (
    <div className="coupon-input-container">
      <label htmlFor="coupon-code">Code promo</label>
      <div className="coupon-input-group">
        <input
          id="coupon-code"
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="Ex: CLUB2026"
          disabled={loading}
          data-testid="coupon-input"
          className="coupon-input"
        />
        <button
          type="button"
          onClick={handleApply}
          disabled={loading || !code.trim()}
          data-testid="apply-coupon-button"
          className="apply-button"
        >
          {loading ? 'Validation...' : 'Appliquer'}
        </button>
      </div>
      {error && (
        <p className="error-message" data-testid="coupon-error">
          {error}
        </p>
      )}
    </div>
  )
}

export default CouponInput
